import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import PackagesExplorer from "./packages_explorer";
import "whatwg-fetch";

// Polyfills Promise API.
import Promise from "promise-polyfill"; 
if (!window.Promise) { window.Promise = Promise; }

ReactDOM.render(<PackagesExplorer />, document.getElementById("packages_explorer"));



// WEBPACK FOOTER //
// ./src/index.js